import React, { useContext } from 'react'
import { Box, Flex, Heading } from 'pcln-design-system'
import PopularDestinationTile from './PopularDestinationTile'
import DESTINATIONS from './constants'
import { SetiRedesignContext } from '../providers/RedesignProvider'

const PopularDestination = () => {
  const { isHPCornerShadowColorRedesign, isHPTextVariant } =
    useContext(SetiRedesignContext)

  return (
    <Box maxWidth={1280} mx="auto" mb={5} color="background.lightest">
      <Heading
        color={isHPTextVariant ? 'text.heading' : 'text'}
        fontSize={4}
        fontWeight="bold"
        pb={2}
        pt={isHPCornerShadowColorRedesign ? 2 : 5}
        px={3}
        mt={isHPCornerShadowColorRedesign ? 1 : ''}
        textStyle={isHPTextVariant ? 'heading2' : ''}
      >
        Discover deals in every city
      </Heading>
      <Flex mx={2} flexWrap="wrap">
        {DESTINATIONS.map(destination => (
          <PopularDestinationTile
            destination={destination}
            key={destination.title}
          />
        ))}
      </Flex>
    </Box>
  )
}

export default PopularDestination
